<template>
  <ConnectAccountsLayout
    :show-error="showError"
    :show-product-message="false"
    :event-tracking-fields="commonTrackingFields"
  >
    <template #titles>
      <h2 :class="$style.heading">
        {{ $t('data.onboarding.steps.connectMarketing.title') }}
      </h2>
      <p :class="$style['sub-heading']">
        {{ $t('data.onboarding.steps.connectMarketing.subtitle') }}
        <button
          v-tooltip.focus.bottom="{
            value: $t('paymentsPage.marketingTooltip'),
            class: $style['mobile-marketing-tooltip'],
            escape: true,
          }"
          type="button"
          class="pi pi-info-circle"
          :class="$style.tooltip"
        />
      </p>
    </template>
    <ProductMessage />
    <ConnectedAccountMarketingTileGroup
      ref="tileGroup"
      v-model:show-error="showError"
      :event-tracking-fields="commonTrackingFields"
      load-all-platforms
    />
    <template #cta>
      <ConnectedAccountConnectButton
        :id="`${$route.name}-checkbox`"
        center-cta
        :cta-text="$t('common.buttons.done')"
        :checkbox-text="$t('common.buttons.skipForNow')"
        :value="skipStep"
        :event-tracking-fields="commonTrackingFields"
        :class="$style['next-btn']"
        @ctaClick="nextStep"
        @checkboxClick="
          (newVal) => {
            skipStep = newVal;
          }
        "
      />
    </template>
  </ConnectAccountsLayout>
</template>

<script>
import { mapGetters, useStore } from 'vuex';
import stateModuleAware from '@/mixins/state-module-aware';
import { mapStateModuleGetters } from '@/utils/state-modules';
import { RouteNames } from '@/data/routes';
import { useProfiling } from '@/composables/useProfiling';

import ConnectedAccountMarketingTileGroup from '@/pages/connected-accounts/components/ConnectedAccountMarketingTileGroup.vue';
import ConnectedAccountConnectButton from '@/pages/connected-accounts/components/ConnectedAccountConnectButton.vue';
import ConnectAccountsLayout from '@/components/layouts/ConnectAccountsLayout.vue';
import ProductMessage from '@/components/banners/ProductMessage.vue';

export default {
  components: {
    ConnectedAccountMarketingTileGroup,
    ConnectAccountsLayout,
    ConnectedAccountConnectButton,
    ProductMessage,
  },
  mixins: [stateModuleAware],
  data() {
    return {
      showError: false,
      skipStep: false,
    };
  },
  setup() {
    const store = useStore();
    const tracking = useProfiling(RouteNames.CONNECTED_ACCOUNTS.MARKETING, {
      type: store.getters.eventTypeBasedOnLoginsCount,
    });

    return {
      tracking,
    };
  },
  computed: {
    ...mapGetters(['productSegmentLabel', 'hasConnectedMarketingAccount']),
    ...mapStateModuleGetters(['experimentName']),
    currentRoute() {
      return this.$route.name;
    },
    commonTrackingFields() {
      return {
        productSegment: this.productSegmentLabel,
        experiment: this.experimentName,
        targetArea: this.currentRoute,
      };
    },
  },
  methods: {
    nextStep() {
      if (!this.skipStep && !this.hasConnectedMarketingAccount) {
        this.showError = true;
        return;
      }

      this.tracking.finish();

      this.$router.push({
        name: RouteNames.HOME.INITIAL,
      });
    },
  },
};
</script>

<style lang="less" module>
.mobile-marketing-tooltip {
  @media (max-width: @medium-screen) {
    left: 0 !important;
    margin: 0 20px 0 20px;
    max-width: fit-content !important;
    div:first-child {
      display: none;
    }
  }
}

.tooltip {
  color: @color-black;
  padding: 4px;
  cursor: help;
}

.next-btn {
  button {
    background-color: @color-purple-2022;
    &:hover {
      background-color: @color-purple-2022 !important;
    }
  }
}
h2.heading {
  font-size: 21px;
  line-height: 30px;
  font-weight: 500;
  margin: 0 0 24px;
}
.sub-heading {
  margin: 0 auto 20px;
  max-width: 550px;
}
@media screen and (max-width: 500px) {
  h2.heading,
  .sub-heading {
    text-align: left;
  }
}
</style>
